import { FilePath } from 'app/model/dataset/file-path';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Location } from 'app/model/dataset/location/location';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { ILocationPath, LakehouseLinkedService } from 'shell-models-lib';

@Metamodel.model({
    name: 'LakehouseLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(LakehouseLinkedService)
    }
})
export class LakehouseLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;

    @Metamodel.attribute({
        display: stringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    @Metamodel.attribute({
        display: stringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', LakehouseLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', LakehouseLocation.FILE_NAME, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: LakehouseLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: LakehouseLocation.FILE_NAME.templateValue(this) || this.fileName,
        };
    }

    public getFolderPath(): string {
        return this.folderPath;
    }

    public getFileName(): string {
        return this.fileName;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && LakehouseLocation.FILE_NAME.templateValue(this)
            ? false
            : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(LakehouseLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(LakehouseLocation.FILE_NAME.templateValue(this));
    }
}
